export default __webpack_public_path__ + "static/media/ic_oman.0dd6eda3.svg";